// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__oxaGN","meals-appear":"AvailableMeals_meals-appear__dSART"};